import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import "../styles/CQP.css";


export default function Cqp() {


  const ITEMS = [
  "Le CQP Instructeur Fitness complet référentiel OC Sport — Volume horaire total : 490 heures — 280 heures en centre, 210 heures en structure.",
  "Les certifications Pilates Mat 1, Pilates Reformer et Running, une spécialisation exclusive et unique en France.",
  "Les 8 modules opérationnels exclusifs Le Hyve Academy (M1 à M8)",
  "L'accompagnement du stage pratique de 105h en structure partenaire",
  "Le stage dans nos locaux sur concours",
  "L'accès aux supports de cours complets (livret d'accueil, fiches modules, ressources)",
  "Financement éligible : CPF / OPCO / financement personnel"
];



  return (
    <>
    <div className="cqp"> 
      <div className="cqp-hero">
        <video className="home-hero-video" autoPlay loop muted playsInline>
          <source src="/Assets/bootcamp_video2.mp4" type="video/mp4" />
        </video>
        <h1 className="cqp-title">CQPIF</h1>
         {/* <p><br/>(certificat de qualification professionnelle <br/> instucteur fitness niveau 3 ) </p>  */}
      
   </div>


<section className="formation-banner">
  <div className="formation-left">
    <p className="formation-subtitle">DEVENEZ</p>
    <h1 className="formationcqp-title">
      COACH FITNESS
      <br />
      PROFESSIONNEL
    </h1>
  </div>

  <div className="formation-right">
    <h2 className="formation-price">4 990 €</h2>
    <p className="formation-tva">TOUT INCLUS</p>

   
    
      <Link to="/programme-cqp" className="formation-btn">
        INSCRIPTION
      </Link>
  </div>

  <div className="formation-stats">
    <div className="stat">
      <h3>8</h3>
      <p>MODULES EXCLUSIFS</p>
    </div>

    <div className="stat">
      <h3>350H</h3>
      <p>DE FORMATION</p>
    </div>

    <div className="stat">
      <h3>1 WE / 2</h3>
      <p>RYTHME COMPATIBLE</p>
    </div>
  </div>
</section>
    

<section className="cqp-presentation">
  <div className="presentation-top">

    <div className="cqp-presentation-text">
      <h1>Une formation complète</h1>

      <p>
        En 6 mois, vous obtenez une certification reconnue par l'État, mais aussi
        toutes les compétences qu'aucune autre formation ne vous donnera :
        savoir trouver vos clients, gérer vos réseaux sociaux, construire votre
        image de marque et créer des séances mémorables.
        <br /><br />
        Tout ça, en vous immergeant dans une vraie salle de sport parisienne,
        entouré de vrais professionnels.
      </p>

      <br /><br />
      <span className="duration-label">POUR QUI</span>
      <br />
      <br />

    <p>
      <strong>RECONVERSIONS PROFESSIONNELLES</strong><br />
      Vous cherchez un métier passion, un nouveau départ, une carrière qui a du sens.
      <br />

      <strong>SPORTIFS PASSIONNÉS</strong><br />
      Vous avez le niveau, vous savez entraîner, mais il vous manque les outils
      pour en faire un vrai métier.
      <br />

      <strong>COACHS DÉJÀ ACTIFS</strong><br />
      Vous êtes sur le terrain mais vous voulez vous certifier, vous perfectionner
      et vous différencier.
    </p>

    
    </div>
    

    <div className="presentation-image">
      <img src="/Assets/masterclass2.png" alt="running girl" />
    </div>

  </div>

  
</section>


<section className="pourquoi-section">
  <div className="pourquoi-image" />

    <div className="pourquoi-content">
      <h2 className="pourquoi-title">Pourquoi Le Hyve ?</h2>
        <p>
          Les formations classiques enseignent un métier. Le Hyve vous apprend
          aussi à <strong>développer votre activité</strong> grâce à{" "}
          <strong>des modules business et image de marque.</strong>
        </p>
        <p>
          Là où les certifications complémentaires sont souvent payantes et
          séparées, <strong>Le Hyve les intègre directement au parcours.</strong>
        </p>
        <p>
          Chaque apprenant bénéficie d'un coach référent dédié pour un
          accompagnement personnalisé.
        </p>
        <p>
          Plus qu'une formation théorique, Le Hyve propose une{" "}
          <strong>immersion terrain</strong> au plus près de la réalité du métier.
        </p>
  </div>
</section>

<section className="inclus-section">
      <div className="inclus-content">
        <h2 className="inclus-title">
          Ce qui est inclus<br />dans la formation
        </h2>
        <ul className="inclus-list">
          {ITEMS.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </div>

      <div className="inclus-cta-wrapper">
         <a href="/programme-cqp" className="inclus-cta">
                PROGRAMME
          </a>
      </div>
</section>

   
    </div>
          <Footer backgroundColor="black" />

    </>
    
   
  );
}